var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    : _c(
        "div",
        { staticClass: "box" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "column col-margin" },
              [
                _c("div", { staticClass: "download" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.downloadCSV }
                    },
                    [_vm._v("Download Report")]
                  )
                ]),
                _vm._v(" "),
                _c("h1", { staticClass: "title-heading" }, [
                  _vm._v("Base2 Ops Tools Status")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "description" }, [
                  _vm._v(
                    "Availability and Security incidents for base2 critical ops tools (OpenVPN and Elmer) over the last 12 months"
                  )
                ]),
                _vm._v(" "),
                _c("h2", { staticClass: "status-heading" }, [
                  _vm._v("Availability")
                ]),
                _vm._v(" "),
                _c("Uptime", {
                  attrs: { data: _vm.availabilityData },
                  on: {
                    select: function(payload) {
                      _vm.clickbar(payload)
                    }
                  }
                }),
                _vm._v(" "),
                _c("h2", { staticClass: "status-heading" }, [
                  _vm._v("Security")
                ]),
                _vm._v(" "),
                _c("Uptime", {
                  attrs: { data: _vm.securityData },
                  on: {
                    select: function(payload) {
                      _vm.clickbar(payload)
                    }
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "slide" } }, [
            _vm.barSelected
              ? _c(
                  "div",
                  { staticClass: "pane" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "close-pane",
                        on: {
                          click: function($event) {
                            return _vm.closePane()
                          }
                        }
                      },
                      [_vm._v("X")]
                    ),
                    _vm._v(" "),
                    _c("h4", [
                      _vm._v(
                        _vm._s(_vm.selectedBar.month) +
                          " " +
                          _vm._s(_vm.selectedBar.year)
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.selectedBar.incidents, function(incident) {
                      return _c("div", { key: incident.date }, [
                        _c("div", { staticClass: "incident-date" }, [
                          _vm._v(_vm._s(incident.date))
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(incident.description))])
                      ])
                    }),
                    _vm._v(" "),
                    _vm.selectedBar.incidents.length == 0
                      ? _c("div", [
                          _c("div", { staticClass: "no-incidents" }, [
                            _vm._v("No incidents")
                          ])
                        ])
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ])
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a905ffa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a905ffa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/OpsTools.vue
// module id = null
// module chunks = 